var storefrontApp = angular.module("storefrontApp");
storefrontApp.service("accountService", [
    "$http",
    function ($http) {
        return {
            areDesignFilesValid: function (fileUploadList, files) {
                var formData = new FormData();
                formData.append(
                    "fileUploadList",
                    angular.toJson(fileUploadList)
                );
                angular.forEach(files, function (file, index) {
                    formData.append("file" + index, file, file.name);
                });
                return $http.post(
                    "storefrontapi/account/contributions/aredesignfilesvalid",
                    formData,
                    {
                        headers: { "Content-Type": undefined },
                    }
                );
            },
            changePassword: function (changePassword) {
                return $http.post(
                    "storefrontapi/account/password",
                    changePassword
                );
            },
            updatePassword: function (password) {
                return $http.post(
                    "storefrontapi/account/update-password",
                    password
                );
            },
            enqueueProduct: function (productQueue, imageFile, designFiles) {
                var formData = new FormData();
                formData.append("productQueue", angular.toJson(productQueue));
                formData.append("imageFile", imageFile, imageFile.name);
                angular.forEach(designFiles, function (file) {
                    formData.append("designFile", file, file.name);
                });
                return $http.post(
                    "storefrontapi/account/contributions/enqueueproduct",
                    formData,
                    {
                        headers: { "Content-Type": undefined },
                    }
                );
            },
            getContributorName: function () {
                return $http.get(
                    "storefrontapi/account/contributions/contributorname?t=" +
                        new Date().getTime()
                );
            },
            getCurrentCustomer: function () {
                return $http.get(
                    "storefrontapi/account?t=" + new Date().getTime()
                );
            },
            getCustomerContributionSettings: function () {
                return $http.get(
                    "storefrontapi/account/contributions/settings?t=" +
                        new Date().getTime()
                );
            },
            getCustomerEmailSubscriptions: function (userId) {
                return $http.get(
                    "emailcampaign/getusersubscriptions?userId=" + userId
                );
            },
            getCustomerSubscriptionVideos: function () {
                return $http.get(
                    "storefrontapi/account/subscriptionvideos?t=" +
                        new Date().getTime()
                );
            },
            updateCustomerEmailSubscriptions: function (
                campaignIds,
                optIns,
                userId
            ) {
                return $http.post(
                    "emailcampaign/updateuseremailsubscriptions",
                    {
                        campaignIds: campaignIds,
                        optIns: optIns,
                        userId: userId,
                    }
                );
            },
            updateCustomerProfile: function (customerProfile) {
                return $http.post("account/updateprofile", customerProfile);
            },
            updateCustomerSubscriptionVideoIsWatched: function (
                customerSubscriptionVideo
            ) {
                return $http.post(
                    "storefrontapi/account/subscriptionvideos/watched",
                    customerSubscriptionVideo
                );
            },
            validateImageFileDimensions: function (file) {
                var formData = new FormData();
                formData.append("file", file);
                return $http.post(
                    "storefrontapi/account/contributions/isvalidimagefile",
                    formData,
                    {
                        headers: { "Content-Type": undefined },
                    }
                );
            },
            resendEmailVerificationLink: function (userId) {
                return $http.post('account/resendverifyaccountemail?userId=' + userId)
            },
        };
    },
]);
